/**
 * 用户状态管理
 */
import { login, getMemberInfo, logout as apiLogout } from '@/api/user'

const state = {
  token: localStorage.getItem('token') || '',
  userInfo: null,
  roles: [],
  userType: parseInt(localStorage.getItem('userType')) || 0, // 0:管理员, 1:从业人员
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  CLEAR_TOKEN(state) {
    state.token = ''
    state.userInfo = null
    state.roles = []
    state.userType = 0
    localStorage.removeItem('token')
    localStorage.removeItem('username')
    localStorage.removeItem('userType')
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  },
  SET_ROLES(state, roles) {
    state.roles = roles
  },
  SET_USER_TYPE(state, type) {
    state.userType = type
    localStorage.setItem('userType', type)
  },
}

const actions = {
  // 登录
  async login({ commit, dispatch }, loginForm) {
    // 调用后端登录接口
    const data = await login(loginForm)

    // 从后端返回的数据中获取 token
    const token = data?.token
    if (!token) {
      throw new Error('登录失败：未获取到 token')
    }

    commit('SET_TOKEN', token)

    // 登录成功后获取用户信息
    await dispatch('getUserInfo')

    return { token, ...data }
  },

  // 获取用户信息
  async getUserInfo({ commit }) {
    try {
      const data = await getMemberInfo()
      // 响应拦截器已返回 data 数据
      const userInfo = {
        nickname: data.nickname,
        instname: data.instname,
        instid: data.instid,
        posid: data.posid,
        mobile: data.mobile,
        username: data.nickname || localStorage.getItem('username'),
      }
      commit('SET_USER_INFO', userInfo)
      return userInfo
    } catch (error) {
      console.error('获取用户信息失败:', error)
      return null
    }
  },

  // 退出登录
  async logout({ commit }) {
    try {
      // 调用后端退出登录接口
      await apiLogout()
    } catch (error) {
      console.error('退出登录接口调用失败:', error)
    } finally {
      // 清除本地状态
      commit('CLEAR_TOKEN')
    }
  },

  // 重置状态
  resetState({ commit }) {
    commit('CLEAR_TOKEN')
  },
}

const getters = {
  isLoggedIn: (state) => !!state.token,
  username: (state) =>
    state.userInfo?.nickname ||
    state.userInfo?.username ||
    localStorage.getItem('username'),
  userRole: (state) => {
    if (state.userType === 0) return 'admin'
    if (state.userType === 1) return 'practitioner'
    if (state.userType === 2) return 'superadmin'
    return 'admin'
  },
  userInfo: (state) => state.userInfo,
  institutionName: (state) => state.userInfo?.instname || '',
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
